import React, { useEffect } from 'react';
import './../../styles/admin/home.css';
import { useNavigate } from 'react-router-dom';

const Admin_home = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/admin/pedidos');
    }, []);

    return (
        <div>
            Cargando...
        </div>
    );
};

export default Admin_home;